export const ONE_TIME_MEETING = { 'data-testid': 'oneTimeMeeting' };
export const EXISTING_MEETING = { 'data-testid': 'existingMeeting' };
export const ROOM_SYSTEM = { 'data-testid': 'roomSystem' };
export const DIRECT_MEETING = { 'data-testid': 'directMeeting' };
